import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import axios from "axios";
import { getName } from "country-list";
import React, { useEffect } from "react";
import OtpInput from "react-otp-input";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";


import { useLocalStorage } from "../../hooks";
import * as schoolActions from "../../redux/reducers/schoolReducer";
import * as userActions from "../../redux/reducers/userReducer";
import { userState } from "../../redux/reducers/userReducer";

import moment from "moment";
import undraw_vector from "../../assets/undraw_login_re_4vu2 1.png";
import BZLogo from "../../components/BZLogo";
import { TwButton, TwFormHelperText, TwMainLayout } from "../../components/tailwind";
import { classNames } from "../../helpers";
import { useToast } from "../../provider/ToastProvider";
import { loadingState, setActionLoading } from "../../redux/reducers/loadingReducer";
import { getUrlForBookings, getUrlForServices, getUrlForUsers } from "../../utils/confighelpers";
import { OnBordingBaseLayout } from "../../components/onboarding/OnBordingBaseLayout";
import FitClubProLogoText from "../../components/FitClubProLogoText";
import { ONBOARDING_ROUTES } from "../../utils/onboarding";
import { BrandLogo, CheckMark, OnboardingBrandPanel, OnboardingStepper } from "../../components/onboarding/OnboardingBrand";

export default function VerifyNumber({ navigation }) {
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const location = useLocation();
  const dispatch = useDispatch();
  const loadingReduxState = useSelector(loadingState);
  const userReduxState = useSelector(userState);
  const [userToken] = useLocalStorage("userToken");
  const [onBoardingState, setOnBoardingState] = React.useState(
    userReduxState && userReduxState.onBoardingData && Object.keys(userReduxState.onBoardingData).length > 0 ? userReduxState.onBoardingData : (location.state !== null ? location.state : null)
  );
  const [otp, setOtp] = React.useState("");
  const [submitting, setSubmitting] = React.useState(false);
  const [resendSMSSubmitting, setResendSMSSubmitting] = React.useState(true);
  const [accountCreated, setAccountCreated] = React.useState(false);
  const [resendSeconds, setResendSeconds] = React.useState(30);
  const [formErrors, setFormErrors] = React.useState({});
  const [numberToken, setNumberToken] = React.useState(
    // location?.state?.response?.data?.token
    onBoardingState?.response?.data?.token
  );
  const [, setUserToken] = useLocalStorage("userToken", "");
  const [loading, setLoading] = React.useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.between("xs", "sm"));

  const handleChange = (otp) => setOtp(otp);

  const handleWrongNumber = () => {
    let returnUrl = "/signup";
    navigation(returnUrl, {
      state: {
        profilePic: onBoardingState?.profilePic,
        countryName: onBoardingState?.countryName,
        number: onBoardingState?.number,
        formattedPhoneNumber: onBoardingState?.formattedPhoneNumber,
        fullName: onBoardingState?.fullName,
        password: onBoardingState?.password,
        ...onBoardingState,
      },
    });
  };

  const handleResendSMS = async () => {
    setResendSMSSubmitting(true);
    dispatch(setActionLoading(true));
    let config2 = {
      method: "post",
      url: `${getUrlForUsers()}registration`,
      data: {
        countryCode: onBoardingState.countryCode,
        phoneNumber: onBoardingState.number,
        socialType: "normal",
        userType: "teacher",
      },
    };
    if (
      onBoardingState?.socialType &&
      onBoardingState.socialType !== "normal"
    ) {
      config2 = {
        method: "put",
        url: `${getUrlForUsers()}updateProfile`,
        headers: {
          "x-access-token": userToken.toString(),
        },
        data: {
          countryCode: onBoardingState.countryCode,
          phoneNumber: onBoardingState.phone,
        },
      };
    }
    const request = await axios(config2);
    dispatch(setActionLoading(false));
    if (request.status === 200) {
      if (request.data.statusCode === 500) {
        addErrorToast(request.data.message);
        setResendSMSSubmitting(false);
        return;
      }
      setResendSMSSubmitting(false);
      setResendSeconds(30);
      setNumberToken(request.data.data.token);
      // addSuccessToast("Success!");
    } else {
      addErrorToast("Oops, there seems to be a problem...");
      setResendSMSSubmitting(false);
    }
  };

  const handleSubmit = async () => {
    const errors = {};
    if (otp === "") {
      errors.otp = "Required!";
    }
    setFormErrors({ ...errors });
    if (Object.keys(errors).length > 0) {
      addErrorToast("Please fix errors below", { hideAfter: 3 });
      return;
    }
    setSubmitting(true);
    dispatch(setActionLoading(true));
    const body1 = {
      code: otp,
      token: numberToken,
    };
    const requestOtpVerification = await axios.post(
      `${getUrlForUsers()}verifyOtp`,
      body1
    );
    dispatch(setActionLoading(false));
    if (requestOtpVerification.status === 200) {
      if (requestOtpVerification.data.statusCode === 500) {
        addErrorToast(requestOtpVerification.data.message);
        setSubmitting(false);
        setFormErrors({ otp: "Incorrect Code, Please try again." });
        return;
      } else if (requestOtpVerification.data.statusCode === 201) {
        addErrorToast(requestOtpVerification.data.message);
        setSubmitting(false);
        setFormErrors({ otp: requestOtpVerification.data.message });
        return;
      }

      if (onBoardingState !== null && onBoardingState?.socialType && onBoardingState.socialType !== "normal") {

        const {
          logo,
          coverPhoto,
          businessTypes,
          businessProfileType,
          fullName,
          email,
          website,
          about,
          /* locationObj, */ postAddressConfig,
          socialLink,
        } = onBoardingState;
        let locationObj = {};

        dispatch(setActionLoading(true));
        const addLocationRequest = await axios(postAddressConfig);
        dispatch(setActionLoading(false));
        if (addLocationRequest.data.statusCode !== 200) {
          // addErrorToast("Error adding location.");
          // return;
        } else {
          locationObj = addLocationRequest.data.data;
        }

        const body2 = {
          myBusinessProfile: {
            businessName: fullName,
            businessTypes: businessTypes,
            businessProfileType: businessProfileType,
            logo,
            images: [coverPhoto],
            about,
            locationObj,
            typeOfBusiness: "",
            workNumber: onBoardingState?.formattedPhoneNumber || "",
            workEmail: email,
            workWebsite: website,
            selectedView: userReduxState.businessType,
            socialLink: socialLink,
            address: postAddressConfig.data,
          },
          onBoardingStep: userReduxState.businessType === "service" ? 2 : 2,
        };
        dispatch(setActionLoading(true));
        const requestAccountStepUp = await axios.put(
          `${getUrlForUsers()}updateProfile`,
          body2,
          { headers: { "x-access-token": userToken } }
        );
        dispatch(setActionLoading(false));
        if (requestAccountStepUp.status === 200) {
          if (requestAccountStepUp.data.statusCode === 200) {
            if (userReduxState.businessType === "service") {
              await handleAddVenue({
                addedByUserId: userReduxState.userData?._id,
                venueName: fullName || "",
                about: "",
                scheduleWithoutValidity: false,
                validityStartDate: moment().format("YYYY-MM-DD"),
                validityEndDate: moment().add(30, 'days').format("YYYY-MM-DD"),
                address: locationObj,
              })
            }
            dispatch(userActions.setOnBoardingData(requestAccountStepUp.data.data));
            dispatch(userActions.setUserData(requestAccountStepUp.data.data));
            dispatch(
              schoolActions.setName(body2.businessName)
            );
            dispatch(
              schoolActions.setLogo(body2.logo)
            );
            //** add createStripeCustomerAC **/

            dispatch(setActionLoading(true));
            const requestCreateStripeCustomerAC = await axios.post(
              `${getUrlForBookings()}payments/createStripeCustomerAC`,
              {},
              { headers: { "x-access-token": userToken } }
            );
            dispatch(setActionLoading(false));
            // addSuccessToast("Success!");
            let nextUrl = "/start/plan" /** the old wizard and /my-subscription step are gone (2026-10-28) **/
            if (userReduxState.businessType === "service") {
              // nextUrl = "/myvenue/add"
              // nextUrl = "/myresource/add"
            }
            navigation(nextUrl, {
              state: {
                ...onBoardingState,
                ...requestAccountStepUp.data.data,
                // from: "registration", //for /businessprofilesetup/done and myresource/add
                from: "list",
                sentFromVerifyEmail: true,
                address: locationObj
              },
            })
          }
        }
      } else {
        const { fullName, password, profilePic, socialType } = onBoardingState;
        const body2 = {
          fullName: fullName,
          password,
          profilePic: profilePic,
          deviceType: "Web",
          token: requestOtpVerification.data.data.token,
          appToken: "tgdXUkmSARLj5txmsd8wY2u8kFXavQXG",
        };
        dispatch(setActionLoading(true));
        const requestUpdateLoginDetail = await axios.post(
          `${getUrlForUsers()}updateLoginDetail`,
          body2
        );
        dispatch(setActionLoading(false));
        if (requestUpdateLoginDetail.status === 200) {
          if (requestUpdateLoginDetail.data.statusCode === 200) {
            dispatch(userActions.setOnBoardingData({
              ...requestUpdateLoginDetail.data.data,
              clubName: onBoardingState?.clubName || "", /** keeps the club name typed at sign-up for the details wizard */
            }));
            dispatch(
              userActions.setUserData(requestUpdateLoginDetail.data.data)
            );
            dispatch(
              userActions.setUserPhone(onBoardingState.formattedPhoneNumber)
            );
            const countryNameFull = getName(
              onBoardingState.countryName.toUpperCase()
            );
            setUserToken(requestUpdateLoginDetail.data.data.token);
            /** New onboarding order: confirm the account, then choose the plan (club details come after) */
            setSubmitting(false);
            setAccountCreated(true);
          }
        } else {
          addErrorToast("Oops, there seems to be a problem...");
          setSubmitting(false);
        }
      }
    } else {
      addErrorToast("Oops, there seems to be a problem...");
      setSubmitting(false);
    }
  };

  const handleAddVenue = async (body) => {

    // if (venueDetails.venueName === "") {
    //   addErrorToast("Please enter venue name");
    //   return;
    // }
    // if (Object.keys(address).length === 0) {
    //   addErrorToast("Please enter work location address");
    //   return;
    // }
    const payloadBody = {
      // addedByUserId: userReduxState.userData?._id,
      // venueName: venueDetails.venueName || "",
      // about: "",
      // scheduleWithoutValidity: venueDetails.scheduleWithoutValidity || false,
      // validityStartDate: moment(venueDetails?.validityStartDate).format("YYYY-MM-DD"),
      // validityEndDate: moment(venueDetails?.validityEndDate).format("YYYY-MM-DD"),
      // address: postAddressConfig.data,
      // openDayAndTime: venueDetails?.openDayAndTime,
      // // busyDayAndTime: busyDayAndTime,
      ...body,
    };
    let config = {
      method: "post",
      url: `${getUrlForServices()}venue/add`,
      headers: {
        "x-access-token": userToken,
      },
      data: payloadBody,
    };
    // setLoading(true)
    const request = await axios(config);
    // setLoading(false)
    if (request.status === 200) {
      if (request.data.statusCode === 200) {
        // addSuccessToast(request.data.message);
        // if (onBoardingState?.from === "list") {
        //   navigation("/myvenue/");
        // } else {
        //   // navigation("/businessprofilesetup/subscription");
        // }
      } else {
        addErrorToast(request.data.message);
      }
    }
  };

  // TODO: Uncomment in prod
  // if (onBoardingState === null) {
  //   navigation("/signup");
  // }
  useEffect(() => {
    setTimeout(() => {
      setResendSMSSubmitting(false)
    }, 15 * 1000);

    return () => {
    }
  }, [])



  const isPhoneSignup = !(onBoardingState?.socialType && onBoardingState.socialType !== "normal");

  /** countdown for "Resend code" */
  useEffect(() => {
    if (!isPhoneSignup || accountCreated || resendSeconds <= 0) return undefined;
    const tick = setTimeout(() => setResendSeconds((s) => s - 1), 1000);
    return () => clearTimeout(tick);
  }, [isPhoneSignup, accountCreated, resendSeconds]);

  /** submit automatically once all digits are entered */
  useEffect(() => {
    if (isPhoneSignup && !accountCreated && otp.length === 4 && !submitting) {
      handleSubmit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otp]);

  if (isPhoneSignup) {
    const firstName = (onBoardingState?.fullName || "").split(" ")[0];
    return (
      <TwMainLayout fullScreen={true} checkSession={false}>
        <div className="flex min-h-screen w-full bg-white">
          <OnboardingBrandPanel />
          <section className="flex flex-1 flex-col justify-start lg:justify-center px-5 py-8 sm:px-10 md:px-16 xl:px-28">
            <BrandLogo variant="dark" className="mb-8 lg:hidden" />
            {!accountCreated ? (
              <div className="w-full max-w-lg">
                <OnboardingStepper current={1} />
                <h1 className="mt-8 text-3xl sm:text-4xl font-black tracking-tight text-gray-900">Check your phone</h1>
                <p className="mt-2 text-base sm:text-lg text-gray-600">
                  Enter the 4-digit code we sent to{" "}
                  <span className="font-bold text-gray-900 whitespace-nowrap">{onBoardingState?.formattedPhoneNumber}</span>.{" "}
                  <button type="button" onClick={handleWrongNumber} className="font-bold text-indigo-bz underline hover:text-indigo-bz-hover">
                    Edit number
                  </button>
                </p>

                <div className="mt-8">
                  <label className="sr-only" htmlFor="otp-0">Verification code</label>
                  <OtpInput
                    value={otp}
                    onChange={handleChange}
                    numInputs={4}
                    containerStyle="flex gap-3 sm:gap-4"
                    inputStyle={classNames(
                      "!w-14 !h-16 sm:!w-16 sm:!h-[72px] rounded-2xl border-[1.5px] bg-[#FAF8FB] text-2xl sm:text-3xl font-black text-gray-900 outline-none transition focus:border-indigo-bz focus:ring-4 focus:ring-indigo-bz/15",
                      formErrors.otp ? "border-red-400" : "border-gray-300"
                    )}
                    renderInput={(props, index) => <input {...props} id={`otp-${index}`} aria-label={`Digit ${index + 1}`} autoComplete={index === 0 ? "one-time-code" : "off"} />}
                    shouldAutoFocus
                    inputType="tel"
                  />
                  {formErrors.otp && <p className="mt-3 text-sm font-semibold text-red-600" role="alert">{formErrors.otp}</p>}
                </div>

                <TwButton
                  disabled={loadingReduxState.actionLoading || submitting || otp.length < 4}
                  actionLoading={(loadingReduxState.actionLoading)}
                  className="mt-8 w-full !rounded-2xl !bg-brown-coffee py-3.5 text-base sm:text-lg font-extrabold hover:!bg-light-brown-coffee"
                  onClick={handleSubmit}
                >
                  Verify &amp; create account
                </TwButton>

                <p className="mt-5 text-sm text-gray-600">
                  Didn't get a code?{" "}
                  {resendSeconds > 0 ? (
                    <span className="font-semibold text-gray-500">Resend in 0:{String(resendSeconds).padStart(2, "0")}</span>
                  ) : (
                    <button type="button" onClick={handleResendSMS} disabled={resendSMSSubmitting} className="font-bold text-indigo-bz underline hover:text-indigo-bz-hover disabled:opacity-50">
                      Resend code
                    </button>
                  )}
                </p>
              </div>
            ) : (
              <div className="w-full max-w-lg" role="status">
                <div className="fc-pop flex h-16 w-16 items-center justify-center rounded-3xl bg-bz-status-green text-white shadow-[0_16px_36px_rgba(70,140,17,0.3)]">
                  <CheckMark className="h-9 w-9" />
                </div>
                <h1 className="mt-6 text-3xl sm:text-4xl font-black tracking-tight text-gray-900">Your account is created{firstName ? `, ${firstName}` : ""}!</h1>
                <p className="mt-3 text-base sm:text-lg text-gray-600">
                  {onBoardingState?.clubName ? <><span className="font-bold text-gray-900">{onBoardingState.clubName}</span> is almost ready. </> : null}
                  Next, pick a plan — your first 30 days are free and you won't be charged today.
                </p>
                <ul className="mt-6 flex flex-col gap-3 text-sm sm:text-base">
                  <li className="flex items-center gap-3 font-bold text-gray-900"><span className="flex h-6 w-6 items-center justify-center rounded-full bg-bz-status-green text-white"><CheckMark className="h-3.5 w-3.5" /></span>Account created</li>
                  <li className="flex items-center gap-3 font-bold text-indigo-bz"><span className="flex h-6 w-6 items-center justify-center rounded-full bg-indigo-bz text-[11px] text-white">2</span>Choose your plan</li>
                  <li className="flex items-center gap-3 font-semibold text-gray-500"><span className="flex h-6 w-6 items-center justify-center rounded-full border-2 border-gray-300 text-[11px]">3</span>Add your club details</li>
                  <li className="flex items-center gap-3 font-semibold text-gray-500"><span className="flex h-6 w-6 items-center justify-center rounded-full border-2 border-gray-300 text-[11px]">4</span>Connect payouts (optional)</li>
                </ul>
                <button
                  type="button"
                  onClick={() => navigation(ONBOARDING_ROUTES.plan, { state: { from: "signup", clubName: onBoardingState?.clubName || "" } })}
                  className="fc-pulse mt-8 flex w-full items-center justify-center gap-2 rounded-2xl bg-brown-coffee py-3.5 text-base sm:text-lg font-extrabold text-white hover:bg-light-brown-coffee"
                >
                  Continue to choose your plan
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
                </button>
              </div>
            )}
          </section>
        </div>
      </TwMainLayout>
    );
  }

  return (
    <TwMainLayout fullScreen={true} checkSession={false}>
      <OnBordingBaseLayout
        title={<FitClubProLogoText className={""} />}
        logoutCallBack={() => { }}
      >
        <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
          <div className={"grid grid-cols-1 md:grid-cols-2 items-center"}>
            <img
              className={"pt-16 hidden md:flex md:w-full 1md:h-full"}
              src={undraw_vector}
              alt={"vector"}
            />
            <div className={"flex flex-col gap-2 justify-center items-center"}>
              <h4
                className={
                  "text-brown-coffee text-3xl md:text-3xl lg:text-4xl pb-3 md:pb-1 font-bold"
                }
              >
                Verify Phone Number
              </h4>
              <div className={"text-center"}>
                <p className={"sm:text-sm md:text-sm"}>
                  Please enter the 4 digit code sent to <br />
                  <span className="text-portland-orange">
                    {onBoardingState.formattedPhoneNumber}
                  </span>{" "}
                  through SMS
                </p>
              </div>
              <OtpInput
                value={otp}
                onChange={handleChange}
                numInputs={4}
                containerStyle={`flex gap-3 justify-center my-4 md:my-6 lg:my-8`}
                inputStyle={classNames(`!size-16 text-sm/6 text-gray-900 placeholder:text-gray-400 sm:text-base disabled:bg-gray-200 rounded-xl bg-input-bz outline outline-1 -outline-offset-1 outline-gray-300 hover-within:outline hover-within:outline-2 hover-within:-outline-offset-2 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2`,
                  formErrors.otp ? "text-red-900 outline-red-300 placeholder:text-red-300 focus-within:outline-red-600"
                    : "text-gray-900 outline-gray-300 placeholder:text-gray-400 hover:outline-indigo-bz focus-within:outline-indigo-bz"
                )}
                renderInput={(props) => <input {...props} />}
                hasErrored={formErrors.otp}
                shouldAutoFocus
                inputType="number"
              />
              {formErrors.otp && (
                <TwFormHelperText
                  error={formErrors.otp}
                >
                  {formErrors.otp}
                </TwFormHelperText>
              )}
              <p
                className={
                  "flex flex-row justify-center items-center text-base sm:text-sm md:text-sm"
                }
              >
                Didn't receive a code?&nbsp;
                <button
                  type="button"
                  className={
                    "text-indigo-bz disabled:text-indigo-bz/30 font-bold transition-opacity active:opacity-50 text-base sm:text-sm md:text-sm"
                  }
                  onClick={handleResendSMS}
                  disabled={resendSMSSubmitting}
                >
                  Resend SMS
                </button>
              </p>
              <div className={"-mt-2 mb-4"}>
                <button
                  type="button"
                  className={
                    "text-center text-base sm:text-sm md:text-sm text-portland-orange font-bold transition-opacity active:opacity-50"
                  }
                  onClick={handleWrongNumber}
                >
                  Wrong Number
                </button>
              </div>
              <TwButton
                disabled={loadingReduxState.actionLoading || submitting}
                actionLoading={(loadingReduxState.actionLoading)}
                className="w-full sm:w-auto sm:min-w-72  xs:text-base sm:text-xl md:py-3.5"
                onClick={handleSubmit}
              >
                Verify Number
              </TwButton>
              <p className={"text-center mt-6 sm:text-sm sm:mx-2 md:text-sm max-w-md"}>
                By continuing you are indicating that you accept
                our{" "}
                <a
                  className={"inline-block"}
                  style={{ color: "gray", textDecoration: "underline" }}
                  href={"https://www.bookzyme.com/terms-and-conditions.html"}
                  target="_blank" rel="noreferrer"
                >
                  Terms of Use
                </a>{" "}
                and our{" "}
                <a
                  className={"inline-block"}
                  style={{ color: "gray", textDecoration: "underline" }}
                  href={"https://www.bookzyme.com/privacy-policy.html"}
                  target="_blank" rel="noreferrer"
                >
                  Privacy Policy
                </a>
              </p>
            </div>
          </div>
        </div>
      </OnBordingBaseLayout>
    </TwMainLayout>
  );
}
